import { getManagetypeKey } from '@/utils/managetype-key';
import store from '@/store';

/* eslint-disable import/prefer-default-export */
export function getPerfChartTypeParams(obj) {
  const managetypeId = obj.objManagetypeId;
  const params = {
    managetypeId,
    managetypeKey: managetypeId === 'DBMS' ? '_' : getManagetypeKey(managetypeId, obj.objDefineId, obj.objtypeId),
  };

  if (managetypeId === 'FMS' || managetypeId === 'NMS') {
    params.objtypeId = obj.objtypeId;
  } else if (managetypeId === 'DBMS') {
    params.objtypeId = '_';
  } else if (managetypeId === 'VMS') {
    params.objtypeId = store.getters.selectedNode.hypervisorType;
  }
  return params;
}
/* eslint-enable import/prefer-default-export */



// WEBPACK FOOTER //
// ./src/utils/performance.js